module.exports = __webpack_public_path__ + "static/media/passive.5c97ebc9.png";